import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: ()=>import('@/pages/Home.vue') 
    },
    {
      path: '/see',
      meta:{menuIndexes:[0]},  //菜单位置,[1级，2级]
      component: ()=>import('@/pages/See.vue') 
    },
    {
      path: '/know',
      meta:{menuIndexes:[1]},
      component: ()=>import('@/pages/Know.vue') 
    },
    {
      path: '/prove',
      meta:{menuIndexes:[2]}, 
      component: ()=>import('@/pages/Prove.vue') 
    },
    // {
    //   path: '/view',
    //   meta:{menuIndexes:[3]}, 
    //   component: ()=>import('@/pages/View.vue') 
    // },
    {
      path: '/meet/:type',
      meta:{menuIndexes:[3]}, 
      component: ()=>import('@/pages/Meet.vue')
      // children:[
      //   {path:'normal',component: ()=>import('@/pages/MeetContent.vue')},
      //   {path:'special',component: ()=>import('@/pages/MeetContent.vue')}
      // ]
    },
    {
      path: '/learn',
      meta:{menuIndexes:[4]}, 
      component: ()=>import('@/pages/Learn.vue') 
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js